import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * Trims all string values in a FormGroup (including nested FormGroups).
 * Call this at the very start of every submit handler, before markAllAsTouched(),
 * so that whitespace-only required fields are caught by Validators.required.
 */
export function trimFormGroup(form: FormGroup): void {
  Object.values(form.controls).forEach((control: AbstractControl) => {
    if (control instanceof FormGroup) {
      trimFormGroup(control);
    } else if (typeof control.value === 'string') {
      const trimmed = control.value.trim();
      if (control.value !== trimmed) {
        control.setValue(trimmed, { emitEvent: false });
      }
    }
  });
}
